var _path, _linearGradient, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeaf2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    enableBackground: "new 0 0 400 400",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9CB686",
    d: "M320.644,190.684c0,33.29-12.67,66.59-38.02,91.939c-12.271,12.26-26.561,21.771-42.13,28.21 c-15.58,6.44-32.44,9.82-49.82,9.82c-34.77,0-67.42-13.5-91.95-38.03c-60.46-60.45-64.989-183.95-64.75-224.81v-0.87 c0.271-12.46,10.24-22.53,22.66-22.96c0.01-0.01,0.021-0.01,0.03,0c0.41-0.01,0.83-0.01,1.27-0.01 c40.971-0.24,164.29,4.35,224.69,64.75C307.974,124.073,320.644,157.373,320.644,190.684z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 168.944,
    x2: 174.224,
    y1: 182.024,
    y2: 187.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.013,
    stopColor: "#33d857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784,
    stopColor: "#009612"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M175.344,186.184h-4.479l-3.04-3.04C169.764,185.033,172.424,186.184,175.344,186.184z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b41",
    d: "M366.034,355.193c0,2.78-1.061,5.55-3.181,7.67c-4.229,4.229-11.09,4.229-15.319,0l-107.721-107.72 h-72.13c-5.989,0-10.84-4.851-10.84-10.83c0-5.99,4.851-10.84,10.84-10.84h50.471l-47.29-47.29H98.724 c-5.989,0-10.84-4.851-10.84-10.841c0-5.979,4.851-10.829,10.84-10.829h50.471l-50.471-50.471c-4.229-4.229-4.229-11.09,0-15.319 c4.23-4.23,11.101-4.23,15.33,0l50.46,50.46v-50.46c0-5.98,4.851-10.83,10.83-10.83c5.99,0,10.84,4.85,10.84,10.83v72.13 l47.29,47.29v-50.46c0-5.98,4.851-10.83,10.84-10.83c5.98,0,10.83,4.85,10.83,10.83v72.14l107.71,107.71 C364.974,349.653,366.034,352.423,366.034,355.193z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3b41",
    d: "M36.67 77.64c0-.17 0-.35.01-.52v.87C36.67 77.87 36.67 77.76 36.67 77.64zM60.64 54.15c-.439 0-.859 0-1.27.01.26-.021.53-.021.8-.021C60.33 54.14 60.48 54.14 60.64 54.15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf2);
export default __webpack_public_path__ + "static/media/leaf-2.a4671731f518de49aba39d73b1355ec1.svg";
export { ForwardRef as ReactComponent };